import { defineStore } from "pinia";
import { inject, ref, toRaw } from "vue";
import { useSpaceStore } from "./spaceStore";

export const useDbStore = defineStore("dbStore", () => {
  const spaceStore = useSpaceStore();
  const rustWorker: Worker = inject("rustWorker");

  const structureDB = ref<IDBDatabase | undefined>(undefined);

  getStructureDB();

  async function getStructureDB() {
    const request = window.indexedDB.open("structure-db", 1);
    request.onerror = (event) => {
      console.error("Why didn't you allow my web app to use IndexedDB?!");
    };

    request.onsuccess = (event) => {
      structureDB.value = request.result;
      console.log("[indexedDb] Structure DB loaded", structureDB.value);

      setTimeout(() => {
        rustWorker.postMessage({
          task: "initIndexedDb",
          data: null
        });
      }, 3000);
    };

    request.onupgradeneeded = () => {
      let db = request.result;

      const objectStore = db.createObjectStore("structure-store", {
        keyPath: "id"
      });

      // objectStore.createIndex("parent", "parent", { unique: false });
      // objectStore.createIndex("level", "level", { unique: false });
      // objectStore.createIndex("children", "children", { unique: false });
      //
    };
  }

  async function saveStructure() {
    if (!structureDB.value) return;

    const transaction = structureDB.value.transaction(
      ["structure-store"],
      "readwrite"
    );
    const objectStore = transaction.objectStore("structure-store");
    Object.entries(spaceStore.calculationElements).forEach(([id, value]) => {
      console.log(value);
      objectStore.put({
        id,
        level: value.level,
        parent: value.parent,
        children: toRaw(value.children)
      });
    });
  }

  async function changeStructureElement(elementId: string) {
    if (!structureDB.value) return;
    if (!spaceStore.calculationElements[elementId]) return;

    const transaction = structureDB.value.transaction(
      ["structure-store"],
      "readwrite"
    );
    const objectStore = transaction.objectStore("structure-store");

    objectStore.put({
      id: elementId,
      level: spaceStore.calculationElements[elementId].level,
      parent: spaceStore.calculationElements[elementId].parent,
      children: toRaw(spaceStore.calculationElements[elementId].children)
    });
  }

  return {
    saveStructure,
    changeStructureElement
  };
});
